import React, { useEffect, useState } from 'react';
import { useAlert } from 'react-alert';
import { useDispatch, useSelector } from 'react-redux';
import {
  fetchEnquetesPergunta, fetchEnquetesRespostas, postEnquetesVotar,
} from '../../api/endpoints';
import { selectLogin } from '../../app/slices/loginSlice';
import { fecharModalEnquete } from '../../app/slices/modalSlice';
import {
  Alerta, Centro, ContainerJanela, Divisor, FormFooter, LabelEnquete, Linha,
} from '../../styles/base';
import Botao from '../Botao/Botao';
import { ReactComponent as EnqueteSvg } from '../../assets/icons/menu/enquete.svg';
import Carregar from '../Carregar/Carregar';
import { LinhaForm } from '../FormControl/FormControlEstilo';
import { JanelaEnquete, TituloEnquete } from './ModalEnqueteEstilo';

const defaultValues = {
  IdEnquete: '',
  IdResposta: '',
};

const ModalEnquete = () => {
  const [pergunta, setPergunta] = useState(null);
  const [listaRespostas, setListaRespostas] = useState(null);
  const [values, setValues] = useState(defaultValues);

  const dispatch = useDispatch();
  const alert = useAlert();
  const dadosLogin = useSelector(selectLogin);

  useEffect(() => {
    Promise.all([
      fetchEnquetesPergunta(),
      fetchEnquetesRespostas(),
    ]).then(([dadosEnquetesPergunta, dadosEnquetesRespostas]) => {
      setPergunta(dadosEnquetesPergunta);
      setListaRespostas(dadosEnquetesRespostas);
    });
  }, [dadosLogin]);

  const setVal = (key, val) => setValues({
    ...values, [key]: val,
  });

  const realizarVoto = async () => {
    const resposta = await postEnquetesVotar({
      ...values,
      IdEnquete: pergunta[0].Id,
    });

    if (resposta.Error === 'Voce ja votou nessa enquete.') {
      return alert.error('Você já votou nessa enquete.', { timeout: 5000 });
    }

    if (resposta.Error) {
      return alert.error('Por favor, selecione uma das alternativas para realizar o voto.', { timeout: 5000 });
    }

    setValues(defaultValues);

    return alert.success('Voto computado.', { timeout: 5000 });
  };

  return (
    <>
      <ContainerJanela>
        <JanelaEnquete>
          <Linha style={{ justifyContent: 'flex-end' }}>
            <Botao
              fechar
              onClick={() => dispatch(fecharModalEnquete())}
            />
          </Linha>

          <TituloEnquete>Enquete</TituloEnquete>

          <Divisor />

          {(!pergunta || !listaRespostas) ? (<Carregar />) : (
            <>
              {pergunta.Message ? (
                <Centro>
                  <EnqueteSvg
                    style={{
                      height: 180, width: 180,
                    }}
                    fill="#dededd"
                  />

                  <Divisor />

                  <Alerta>Não há nenhuma enquete disponível.</Alerta>
                </Centro>
              ) : (
                <>
                  <b>{pergunta[0].Campo}</b>

                  <Divisor />

                  <form>
                    {listaRespostas && listaRespostas.filter((resposta) => resposta.IdEnquete === pergunta[0].Id).map((respostas) => (
                      <div key={respostas.Id}>
                        <LinhaForm>
                          <LabelEnquete htmlFor={`inputResposta${respostas.Id}`}>
                            <input
                              type="radio"
                              name="respostaEnquete"
                              value={respostas.Id}
                              id={`inputResposta${respostas.Id}`}
                              onChange={() => setVal('IdResposta', respostas.Id)}
                            />
                            {' '}
                            {respostas.Campo}
                          </LabelEnquete>
                        </LinhaForm>

                        <Divisor />
                      </div>
                    ))}
                    {(listaRespostas.filter((resposta) => resposta.IdEnquete === pergunta[0].Id).length === 0) && (
                      <p>Nenhuma resposta cadastrada.</p>
                    )}
                  </form>

                  <Divisor />

                  <FormFooter>
                    <Botao
                      label="Votar"
                      onClick={realizarVoto}
                    />
                  </FormFooter>
                </>
              )}

            </>
          )}

        </JanelaEnquete>
      </ContainerJanela>
    </>
  );
};

export default ModalEnquete;
